import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { TabNavigation } from './TabNavigation';
import { ServicePerformance } from '../pages/ServicePerformance';
import { ProcessingAnalytics } from '../pages/ProcessingAnalytics';
import { Revenue } from '../pages/Revenue';
import { UserInsights } from '../pages/UserInsights';
import { SystemHealth } from '../pages/SystemHealth';
interface PerformanceDashboardProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}
export const PerformanceDashboard: React.FC<PerformanceDashboardProps> = ({
  activeTab,
  setActiveTab
}) => {
  const tabs = [{
    id: 'service-performance',
    label: 'Service Performance'
  }, {
    id: 'processing-analytics',
    label: 'Processing Analytics'
  }, {
    id: 'revenue',
    label: 'Revenue'
  }, {
    id: 'user-insights',
    label: 'User Insights'
  }, {
    id: 'system-health',
    label: 'System Health'
  }];
  const renderContent = () => {
    switch (activeTab) {
      case 'service-performance':
        return <ServicePerformance data-id="element-74" />;
      case 'processing-analytics':
        return <ProcessingAnalytics data-id="element-75" />;
      case 'revenue':
        return <Revenue data-id="element-76" />;
      case 'user-insights':
        return <UserInsights data-id="element-77" />;
      case 'system-health':
        return <SystemHealth data-id="element-78" />;
      default:
        return <ServicePerformance data-id="element-79" />;
    }
  };
  return <div className="flex-1 overflow-auto" data-id="element-80">
      <div className="p-6" data-id="element-81">
        <div className="mb-6" data-id="element-82">
          <h1 className="text-2xl font-semibold text-gray-800" data-id="element-83">Performance</h1>
          <p className="text-gray-600" data-id="element-84">
            Public sector service performance data
          </p>
        </div>
        <TabNavigation tabs={tabs} activeTab={activeTab} onChange={setActiveTab} data-id="element-85" />
        <div className="mt-6" data-id="element-86">{renderContent()}</div>
      </div>
    </div>;
};